import * as React from 'react'

import { colors } from '@factorialco/deprecated-design-system'
import { CustomSvgLayerProps } from '@nivo/scatterplot'

// Dear developer,
// Nivo ScatterPlot version 0.73.0 has an issue with exporting types for scales.
// Although the scales are implemented as functions, they are not exported as callable functions.
// I attempted to install the d3-scale types in development, following the suggestions
// mentioned in this GitHub issue: https://github.com/plouc/nivo/issues/1947.
// However, it seems that this solution did not work as expected.
// Until the issue with types is resolved or the charts are upgraded,
// the only viable solution is to bypass the typing for now.

interface Props extends CustomSvgLayerProps {
  salaryRangesThresholds: Array<{ min: number; max: number; levelName: string }>
  xScale: any
  yScale: any
}

const AreaLayer: React.FC<Props> = ({ salaryRangesThresholds, xScale, yScale }) => {
  const d = salaryRangesThresholds.reduce(
    (acc, x, i) => {
      const [top, bottom] = acc
      const nextTop = `${xScale(x.levelName)} ${yScale(x.max)}`
      const closing = i === 0 ? nextTop : ''
      return [`${top} ${nextTop}`, `${xScale(x.levelName)} ${yScale(x.min)} ${bottom} ${closing}`]
    },
    ['M', '']
  )

  return (
    <path d={d.join()} fill="rgba(57, 181, 190, 0.2)" stroke={colors.viridian800} strokeWidth="2" />
  )
}

export default AreaLayer
